import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  "isolated-page": defineAsyncComponent(() => import("/app/layouts/isolated-page.vue").then(m => m.default || m)),
  meetings: defineAsyncComponent(() => import("/app/layouts/meetings.vue").then(m => m.default || m)),
  recordings: defineAsyncComponent(() => import("/app/layouts/recordings.vue").then(m => m.default || m))
}